var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.policy
    ? _c(
        "v-card",
        [
          _c("v-card-title", [_vm._v(_vm._s(_vm.policy.title))]),
          _vm._v(" "),
          _c("v-card-text", {
            domProps: { innerHTML: _vm._s(_vm.policy.content) }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }